import type { Theme } from '@mui/material';

export const styles = {
  content: {
    justifyContent: 'space-between',
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
  },

  overlay: (theme: Theme) => ({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    backgroundColor: theme.colors.white,
    opacity: 0.5,
  }),
};
